import React from 'react';
export const See = () => {
    return (
        <svg
            height="24"
            width="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            focusable="false"
            role="img"
            aria-hidden="true"
        >
            <g fill="currentColor" fill-rule="evenodd">
                <path d="M11.998 20.266a8.09 8.09 0 0 1-.409-.01C5.065 19.932 1.257 13.492.103 11.761a.683.683 0 0 1 .006-.73C8.6-1.44 16.93 4.036 20.884 6.972c1.288.957 2.401 1.781 3.116 1.794-.033.989-1.23 1.444-1.981 1.026-.671-.374-1.065-.73-1.901-1.35-4.273-3.169-10.1-7.49-18.382 3.075 1.173 1.703 5.068 6.78 9.919 7.008 3.055.142 5.99-1.657 8.742-5.356.173-.236.473-.269.672-.066l.369.374c.207.21.229.592.048.836-2.938 3.951-6.127 5.952-9.488 5.952"></path>
                <path d="M11.813 8.5C9.986 8.5 8.5 9.986 8.5 11.813s1.486 3.313 3.313 3.313 3.313-1.486 3.313-3.313S13.64 8.5 11.813 8.5m0 8.126C9.159 16.626 7 14.467 7 11.813S9.159 7 11.813 7s4.813 2.159 4.813 4.813-2.159 4.813-4.813 4.813"></path>
            </g>
        </svg>
    );
};
